<template>
    <ReaderFullViewContentModal v-if="ui.audiobook.about.opened">
        <Container class="h-full scroll-py-2.5 overflow-auto pb-16 pt-8 text-theme-text">
            <Row>
                <LayoutCol>
                    <div class="mx-auto flex w-full max-w-[600px] flex-col gap-2 px-10 md:px-0">
                        <h2 class="mb-0 hyphens-auto break-words text-xl font-bold">
                            {{ title }}
                        </h2>
                        <p v-if="audiobook.chapters" class="mb-0 mt-1">
                            <b>{{ audiobook.chapters }}</b> {{ localizations[lang].chapters }}
                        </p>
                        <p v-if="audiobook.duration" class="mb-0 mt-1">
                            <b>{{ audiobook.duration }}</b> {{ localizations[lang].duration }}
                        </p>
                        <p v-if="authors" :class="{ 'mb-0': !narrators }">
                            <b>{{ localizations[lang].author }}:</b> {{ authors }}
                        </p>
                        <p v-if="narrators" :class="{ 'mb-0': issue.aboutThisPublication.length === 0 }">
                            <b>{{ localizations[lang].narrator }}:</b> {{ narrators }}
                        </p>
                        <p v-if="issue.aboutThisPublication">
                            <b>{{ localizations[lang].aboutThisPublication }}:</b>
                            <!-- eslint-disable-next-line vue/no-v-html -- Sanitized server content -->
                            <span :lang="issue.lang" v-html="issue.aboutThisPublication"></span>
                        </p>
                    </div>
                </LayoutCol>
            </Row>
        </Container>
    </ReaderFullViewContentModal>
</template>
<script>
import { mapState } from 'vuex';
import ReaderFullViewContentModal from '../ReaderModal/ReaderFullViewContentModal.vue';

export default {
    components: { ReaderFullViewContentModal },
    data() {
        return {
            issueTagsElement: null,
        };
    },
    computed: {
        ...mapState(['title', 'localizations', 'lang', 'issue', 'audiobook', 'ui', 'device']),
        authors() {
            return this.getSpecificTag('author');
        },
        narrators() {
            return this.getSpecificTag('narrator');
        },
    },
    mounted() {
        this.issueTagsElement = this.$refs.issueTags;
    },
    methods: {
        getSpecificTag(tagName) {
            return Object.prototype.hasOwnProperty.call(this.issue.tags, tagName) && this.issue.tags[tagName].length > 0
                ? this.issue.tags[tagName].join(', ')
                : null;
        },
    },
};
</script>
